import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	exportErrorFlagDefaultTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exportErrorFlagDefaultDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exportErrorFlagDefaultTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	exportErrorFlagDefaultTitle: {
		id: 'issue-navigator-action-export-issues.common.export-error-flag.export-error-flag-default-title',
		defaultMessage: 'We couldn’t export your issues',
		description: 'Title of export error flag, shown when something wrong happened',
	},
	exportErrorFlagDefaultDescription: {
		id: 'issue-navigator-action-export-issues.common.export-error-flag.export-error-flag-default-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Description of export error flag, shown when something wrong happened',
	},
	exportErrorFlagDefaultTitleIssueTerminologyRefreshM4: {
		id: 'issue-navigator-action-export-issues.common.export-error-flag.export-error-flag-default-title-issue-terminology-refresh-m4',
		defaultMessage: 'We couldn’t export your work items',
		description: 'Title of export error flag, shown when something wrong happened',
	},
});
export default messages;
